/**
 * @desc 明细
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/messageMaster/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
